export default {
    BASE_URL: 'https://apiweb.enginehire.io',
    BASE_WS_URL: "wss://chat.enginehire.io"
}


// WEBPACK FOOTER //
// ./src/environments/production.js